import { Badge } from "@/components/ui/badge";
import { formatQty } from "../lib/confirmedProduction";
import { formatUnit } from "../lib/formatUnit";

const formatAt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN") : "—");

export const WipBadge = ({ wip }) => {
  if (!wip) return <span className="text-[#98A2B3]">—</span>;
  if (wip.skipped) return <Badge variant="outline" className="bg-[#F9FAFB] text-[#667085] border-[#EAECF0]">Pending</Badge>;
  if (wip.success) return <Badge variant="outline" className="bg-[#ECFDF3] text-[#027A48] border-[#ABEFC6]">Cleared</Badge>;
  return <Badge variant="outline" className="bg-[#FEF3F2] text-[#B42318] border-[#FECDCA]">Error</Badge>;
};

// Every individual confirmation behind a summary row - nothing is merged
// away, these are the original transaction records.
export const ConfirmationDetailTable = ({ transactions, testIdPrefix }) => (
  <table className="w-full text-[12px] border-collapse bg-[#FCFCFD]" data-testid={`${testIdPrefix}-detail-table`}>
    <thead>
      <tr>
        {["Date/Time", "Reference", "Qty", "Scrap", "By-product", "Status", "Confirmed By"].map((h) => (
          <th key={h} className="bg-[#F2F4F7] border border-[#EAECF0] px-2 py-1 text-left text-[10px] font-bold text-[#475467] font-heading uppercase tracking-wide">{h}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {transactions.map((t, i) => (
        <tr key={t.record_id || i} data-testid={`${testIdPrefix}-detail-row-${i}`}>
          <td className="border border-[#EAECF0] px-2 py-1 whitespace-nowrap text-[#475467]">{formatAt(t.at)}</td>
          <td className="border border-[#EAECF0] px-2 py-1 font-mono text-[11px] text-[#667085]">
            {t.production_lot_id}/{t.reporting_point_id || "—"}
            <span className="text-[#98A2B3]"> · {(t.record_id || "").slice(-8)}</span>
          </td>
          <td className="border border-[#EAECF0] px-2 py-1 text-right tabular-nums font-medium">{formatQty(t.confirmed_quantity)}</td>
          <td className="border border-[#EAECF0] px-2 py-1 text-right tabular-nums">{formatQty(t.confirmed_scrap)}</td>
          <td className="border border-[#EAECF0] px-2 py-1 text-right tabular-nums">
            {t.byproduct_confirmed_quantity ? `${formatQty(t.byproduct_confirmed_quantity)} ${formatUnit(t.byproduct_unit_code)}`.trim() : "—"}
          </td>
          <td className="border border-[#EAECF0] px-2 py-1">
            <span className="text-[#027A48]">Posted</span>
            <span className="text-[#98A2B3]"> · WIP </span>
            {!t.wip_clearing ? "—" : t.wip_clearing.skipped ? "pending" : t.wip_clearing.success ? "cleared" : "error"}
          </td>
          <td className="border border-[#EAECF0] px-2 py-1 text-[#475467]">{t.actor || "—"}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
